export default __webpack_public_path__ + "static/media/handshake.f7f5d2fa.webp";